module.exports = __webpack_public_path__ + "static/media/full.1c2dc63a.svg";